export type BreakpointsType = 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

export const breakpoints: Record<BreakpointsType, number> = {
  sm: 0,
  md: 768,
  lg: 1024,
  xl: 1440,
  xxl: 1920,
};
